export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑计划',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ hxShipmentJdStatus }) => {
      return !['N', 'C'].includes(hxShipmentJdStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除计划',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ hxShipmentJdStatus }) => hxShipmentJdStatus != 'N',
  },
  {
    text: that.$l('menu_text_confirmPlan') || '确认计划',
    icon: 'el-icon-document-checked',
    menuType: 'confirmPlan',
    divided: true,
    allow: 'C',
    disabled: ({ hxShipmentJdStatus }) => hxShipmentJdStatus != 'N',
  },
  {
    text: that.$l('menu_text_confirmVehicle') || '车辆确认',
    icon: 'el-icon-truck',
    menuType: 'confirmVehicle',
    allow: 'V',
    disabled: ({ hxShipmentJdStatus }) => hxShipmentJdStatus != 'C',
  },
  {
    text: that.$l('menu_text_changePlan') || '计划变更',
    icon: 'el-icon-edit-outline',
    menuType: 'changePlan',
    allow: 'U',
    disabled: ({ hxShipmentJdStatus }) => { return !['C', 'V'].includes(hxShipmentJdStatus) },
  },
  {
    text: that.$l('menu_text_complete') || '出货完成',
    icon: 'el-icon-check',
    menuType: 'complete',
    allow: 'L',
    disabled: ({ hxShipmentJdStatus }) => { return !['V'].includes(hxShipmentJdStatus) },
  },
  {
    text: that.$l('menu_text_shipmentlist') || '出货清单',
    icon: 'el-icon-notebook-1',
    menuType: 'shipmentlist',
    divided: true,
    allow: 'S',
    disabled: ({ hxShipmentJdStatus }) => {
      return ['N', 'D'].includes(hxShipmentJdStatus)
    },
  },
  {
    text: that.$l('menu_text_binsposting') || '分仓箱贴',
    icon: 'el-icon-discount',
    menuType: 'binsposting',
    allow: 'F',
    disabled: ({ hxShipmentJdStatus }) => {
      return ['N', 'D'].includes(hxShipmentJdStatus)
    },
  },

  {
    text: that.$l('menu_text_packinglist') || '装车清单',
    icon: 'fa fa-truck',
    menuType: 'packinglist',
    allow: 'P',
    disabled: ({ hxShipmentJdStatus }) => {
      return !['V', 'Y'].includes(hxShipmentJdStatus)
    },
  },
]
